<modal-container
  #modalHsSupplierConfirm
  [headerIconClass]=""
  [headerTitle]="'automatic-orders.product.supplierConfirm.header'"
  [isLargeModal]="true"
  [hasBackdrop]="true"
  [ignoreBackdropClick]="true"
  [isModalInModal]="true"
  [isHideBtnHidden]="true"
  [hasCustomHeader]="true"
>
  <!--  <ng-container class="modal-button-show">-->
  <!--  </ng-container>-->

  <ng-container class="modal-header-content">
    <h4 class="modal-title">
      <span>
        {{ 'automatic-orders.product.supplierConfirm.header' | translate }}
      </span>
    </h4>
    <button
      data-cy="close"
      type="button"
      class="close"
      aria-label="Close"
      (click)="hideChildModal()"
      [title]="'close' | translate"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </ng-container>

  <ng-container class="modal-body-content">
    <div class="row">
      <div class="col-12">
        {{ 'automatic-orders.product.supplierConfirm.content' | translate }}
      </div>
    </div>
  </ng-container>

  <ng-container class="modal-footer-content">
    <!--    <btn-->
    <!--      [btnType]="'button'"-->
    <!--      [classes]="['btn-third']"-->
    <!--      (click)="hideChildModal()"-->
    <!--      [label]="'close'"-->
    <!--      [title]="'close' | translate"-->
    <!--      [icon]="'far-ban'"-->
    <!--    ></btn>-->
    <btn
      [label]="'automatic-orders.product.supplierConfirm.btn'"
      [title]="'automatic-orders.product.supplierConfirm.btn' | translate"
      [classes]="['btn-first']"
      (onEvent)="connectHsSupplier()"
    ></btn>
  </ng-container>
</modal-container>
